import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";

import "../excalidraw-app/sentry";

// 导入自定义CSS以隐藏文字至图表按钮
import "../packages/excalidraw/css/hide-text-to-diagram.css";
// 导入自定义CSS以隐藏后面两个命令分类
import "../packages/excalidraw/css/hide-command-categories.css";
// 导入自定义CSS以隐藏分享、实时协作和PWA安装命令项
import "../packages/excalidraw/css/hide-command-items.css";
// 导入自定义JavaScript以隐藏命令面板中的文字至图表命令项
import "../packages/excalidraw/js/hide-text-to-diagram-command.js";
// 导入自定义JavaScript以隐藏命令面板中的分享、实时协作和PWA安装命令项
import "../packages/excalidraw/js/hide-share-collab-pwa-commands.js";

import ExcalidrawApp from "./App";

window.__EXCALIDRAW_SHA__ = import.meta.env.VITE_APP_GIT_SHA;
const rootElement = document.getElementById("root")!;
const root = createRoot(rootElement);
registerSW();
root.render(
  <StrictMode>
    <ExcalidrawApp />
  </StrictMode>,
);
